import { GlobalState } from '@leverege/ui-redux';
import Err from '@leverege/error';
import I18N from '@leverege/i18n';
import { LoadingView } from '@leverege/molten/views';
import Util from "../Util.js";
const {
  t
} = I18N.ns('pairing.imagine.PairAction');
export default {
  id: 'imagine.pairing.Pair',
  type: 'imagine.pairing.Pair',
  perform: async cxt => {
    const {
      context: {
        attribute,
        assetDelegate,
        tagDelegate,
        relationship
      },
      onChange,
      setActiveStep,
      setNextDisabled,
      wizardData
    } = cxt;
    const {
      asset,
      tag
    } = wizardData;
    const assetItemDelegate = assetDelegate.item(asset.obj.id);
    const tagItemDelegate = tagDelegate.item(tag.obj.id);
    const assetName = relationship.parentBlueprint.name;
    const tagName = relationship.blueprint.name;
    setNextDisabled(true);
    const close = LoadingView.showDialog(t('loadingDialog', {
      assetName,
      tagName
    }));
    try {
      await GlobalState.dispatch(assetItemDelegate.child(attribute.source.attribute.path).create({
        id: tag.obj.id,
        force: true
      }));
    } catch (err) {
      onChange({
        data: 'error',
        value: Err({
          message: t('pairError', {
            assetName,
            tagName
          }),
          error: err
        })
      });
      setActiveStep('pairingError');
      close();
      return;
    }
    if (asset.data) {
      try {
        await Util.performDeviceUpdates(asset.data, assetItemDelegate, {
          extraFields: attribute.source?.attribute?.metadata?.pairing?.pair?.asset?.extraFields,
          objectType: assetDelegate.relationship.objectType
        });
      } catch (err) {
        onChange({
          data: 'error',
          value: Err({
            message: t('assetUpdateError', {
              assetName
            }),
            error: err
          })
        });
        setActiveStep('pairingError');
        close();
        return;
      }
    }
    if (tag.data) {
      try {
        await Util.performDeviceUpdates(tag.data, tagItemDelegate, {
          extraFields: attribute.source?.attribute?.metadata?.pairing?.pair?.tag?.extraFields,
          objectType: tagDelegate.relationship.objectType
        });
      } catch (err) {
        onChange({
          data: 'error',
          value: Err({
            message: t('tagUpdateError', {
              tagName
            }),
            error: err
          })
        });
        setActiveStep('pairingError');
        close();
        return;
      }
    }
    GlobalState.dispatch(assetItemDelegate.get());
    close();
    setActiveStep('pairingSuccess');
  }
};